import { render, staticRenderFns } from "./SmsConsentFields.vue?vue&type=template&id=e677c0e4&scoped=true&"
import script from "./SmsConsentFields.vue?vue&type=script&lang=js&"
export * from "./SmsConsentFields.vue?vue&type=script&lang=js&"
import style0 from "./SmsConsentFields.vue?vue&type=style&index=0&id=e677c0e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e677c0e4",
  null
  
)

export default component.exports